import { social } from '../../../src/settings/custom/build'
export const animations = {
  big: { spine: 'animations/spine/win/skeleton.json' },
  mega: { spine: 'animations/spine/win/skeleton.json' },
  ultra: { spine: 'animations/spine/win/skeleton.json' },
  bonusMultiplier: { spine: 'animations/spine/multiplier/skeleton.json' },
  bonusNames: social ? { spine: 'animations/spine/bonus-names-sc/skeleton.json' } : { spine: 'animations/spine/bonus-names/skeleton.json' },
}

export const time = 2.4

export const winParticles = {
  big: ['coin'],
  ultra: ['coin'],
  mega: ['coin'],
}
export const isNewBigWin = true
